import React, { useState } from 'react';
import '../styles/HotelList.css';
import hotelsData from '../data/hotels.json';
import logo from '../assets/logo3.webp'; 
import ad1 from '../assets/ad.jpg'; // advertisement banner
import { Link, useLocation } from 'react-router-dom';
import { HiOutlineLocationMarker, HiStar, HiOutlineCheckCircle, HiOutlineCurrencyRupee } from 'react-icons/hi';

const imageMap = {
  '../assets/himalayanretreat.png': require('../assets/himalayanretreat.png'),
  '../assets/desertpearl.png': require('../assets/desertpearl.png'),
  '../assets/costalbliss.png': require('../assets/costalbliss.png'),
  '../assets/imperial.png': require('../assets/imperial.png'),
  '../assets/umaid.png': require('../assets/umaid.png'),
  '../assets/oberoi.png': require('../assets/oberoi.png'),
  '../assets/leelaudaipur.png': require('../assets/leelaudaipur.png'),
  '../assets/tajudaipur.png': require('../assets/tajudaipur.png'),
  '../assets/taj.png': require('../assets/taj.png'),
  '../assets/wildflower.png': require('../assets/wildflower.png'),
  '../assets/streggis.png': require('../assets/streggis.png'),
  '../assets/ananta.png': require('../assets/ananta.png'),
  '../assets/welcomhotel.png': require('../assets/welcomhotel.png'),
  '../assets/aahana.png': require('../assets/aahana.png'),
  '../assets/tajtheog.png': require('../assets/tajtheog.png'),
  '../assets/w.png': require('../assets/w.png'),
  '../assets/lalit.png': require('../assets/lalit.png'),
  '../assets/nainiretreat.png': require('../assets/nainiretreat.png'),
  '../assets/neemrana.png': require('../assets/neemrana.png'),
  '../assets/burjal.png': require('../assets/burjal.png'),
  '../assets/atlantis.png': require('../assets/atlantis.png'),
    '../assets/emirates.png': require('../assets/emirates.png')

};

// Hero Banner
const HotelHero = () => {
  return (
    <div className="hotel-hero-modern">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Find the Perfect Stay</h1>
        <p>Explore curated luxury hotels across your favorite destinations.</p>
      </div>
    </div>
  );
};

const HotelList = () => {
  const [selectedState, setSelectedState] = useState('All');
  const [filters, setFilters] = useState({
    priceLow: false,
    priceHigh: false,
    ratingHigh: false
  });

  const location = useLocation();
  const states = ['All', ...new Set(hotelsData.map(hotel => hotel.state))];

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFilters(prev => ({ ...prev, [name]: checked }));
  };

  const applyFilters = () => {
    let filtered = selectedState === 'All'
      ? [...hotelsData]
      : hotelsData.filter(hotel => hotel.state === selectedState);

    if (filters.priceLow && !filters.priceHigh) {
      filtered.sort((a, b) => a.pricePerNight - b.pricePerNight);
    } else if (filters.priceHigh && !filters.priceLow) {
      filtered.sort((a, b) => b.pricePerNight - a.pricePerNight);
    }

    if (filters.ratingHigh) {
      filtered.sort((a, b) => b.rating - a.rating);
    }
    return filtered;
  };

  const filteredHotels = applyFilters();

  return (
    <>
     <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <a href="#" className="contact-dropbtn">Destinations</a>
  
<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels" className={location.pathname === '/hotels' ? 'active-link' : ''} >Hotels</Link>
        <Link to="/contact-us">Contact Us</Link>
          
        </nav>
          <Link to="/booknow">
        <button className="contact-book-btn">Book Now</button>
                                    </Link>
      </header>
      <HotelHero />

      <div className="hotel-list-container">
        {/* Modern Pill Selector instead of Circles */}
        <div className="city-pill-selector">
          {states.map((state, index) => (
            <button
              key={index}
              className={`pill-btn ${selectedState === state ? 'active' : ''}`}
              onClick={() => setSelectedState(state)}
            >
              {state}
            </button>
          ))}
        </div>

        <div className="hotels-main-layout">
          {/* Modernized Sidebar */}
          <aside className="hotels-sidebar-modern">
            <div className="sidebar-header">
              <div className="accent-line"></div>
              <h3>Refine Search</h3>
            </div>
            <div className="filter-group-modern">
              <p className="filter-label">Sort by Price</p>
              <label className={`custom-check ${filters.priceLow ? 'active' : ''}`}>
                <input type="checkbox" name="priceLow" checked={filters.priceLow} onChange={handleCheckboxChange} />
                <span className="dot"></span> Lowest First
              </label>
              <label className={`custom-check ${filters.priceHigh ? 'active' : ''}`}>
                <input type="checkbox" name="priceHigh" checked={filters.priceHigh} onChange={handleCheckboxChange} />
                <span className="dot"></span> Highest First
              </label>
              <p className="filter-label">Ratings</p>
              <label className={`custom-check ${filters.ratingHigh ? 'active' : ''}`}>
                <input type="checkbox" name="ratingHigh" checked={filters.ratingHigh} onChange={handleCheckboxChange} />
                <span className="dot"></span> Top Rated
              </label>
            </div>
            <div className="sidebar-ad-card">
              <img src={ad1} alt="Ad" />
            </div>
          </aside>

          {/* Modernized Hotel Grid */}
          <div className="hotel-grid-modern">
            {filteredHotels.map(hotel => (
              <div className="hotel-row-card" key={hotel.id}>
                <div className="hotel-card-image">
                  <img src={imageMap[hotel.image]} alt={hotel.name} />
                  <div className="hotel-rating-badge"><HiStar /> {hotel.rating}</div>
                </div>
                <div className="hotel-card-body">
                  <div className="hotel-card-header">
                    <h3>{hotel.name}</h3>
                    <p className="loc-tag"><HiOutlineLocationMarker /> {hotel.city}, {hotel.state}</p>
                  </div>
                  <div className="hotel-amenities-tags">
                    {hotel.amenities.slice(0, 4).map((item, idx) => (
                      <span key={idx} className="tag-item"><HiOutlineCheckCircle /> {item}</span>
                    ))}
                  </div>
                  <div className="hotel-card-footer">
                    <div className="price-box">
                      <span className="price-small">Starting at</span>
                      <span className="price-main">₹{hotel.pricePerNight.toLocaleString()}</span>
                    </div>
                    <Link to={`/hotels/${hotel.id}`} className="view-btn-modern">View Details</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default HotelList;
